<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <t4-container title="{{ 'Turbo.TroubleshootSold.Header' | translate:'Why not sold?' }}">
    <div *ngIf="!isLoading">
      <div class="checklist-container">
        <div class="icon-container">
          <mat-icon *ngIf="checklist && checklist.TerminationCreated" class="checklist-icon green">check_circle</mat-icon>
          <mat-icon *ngIf="checklist && !checklist.TerminationCreated" class="checklist-icon red">cancel</mat-icon>
        </div>
        <div class="checklist-name">{{ 'Turbo.TroubleshootSold.TerminationNearing' | translate:'Terminated or nearing termination?' }}</div>
      </div>
      <div class="dots-container">
        <div class="dot"></div>
      </div>
      <div class="checklist-container">
        <div class="icon-container">
          <mat-icon *ngIf="checklist && checklist.CustomerNotBlocked" class="checklist-icon green">check_circle</mat-icon>
          <mat-icon *ngIf="checklist && !checklist.CustomerNotBlocked" class="checklist-icon red">cancel</mat-icon>
        </div>
        <div class="checklist-name">{{ 'Turbo.TroubleshootSold.CustomerNotBlocked' | translate:'Is customer not blocked?' }}</div>
      </div>
      <div class="dots-container">
        <div class="dot"></div>
      </div>
      <div class="checklist-container">
        <div class="icon-container">
          <mat-icon *ngIf="checklist && checklist.InvoiceDatePassed" class="checklist-icon green">check_circle</mat-icon>
          <mat-icon *ngIf="checklist && !checklist.InvoiceDatePassed" class="checklist-icon red">cancel</mat-icon>
        </div>
        <div class="checklist-name">{{ 'Turbo.TroubleshootSold.InvoiceDatePassed' | translate:'Invoice date passed?' }}</div>
      </div>
      <div class="dots-container">
        <div class="dot"></div>
      </div>
      <div class="checklist-container">
        <div class="icon-container">
          <mat-icon *ngIf="checklist && checklist.NotAlreadySold" class="checklist-icon green">check_circle</mat-icon>
          <mat-icon *ngIf="checklist && !checklist.NotAlreadySold" class="checklist-icon red">cancel</mat-icon>
        </div>
        <div class="checklist-name">{{ 'Turbo.TroubleshootSold.NotAlreadySold' | translate:'Vehicle not sold?' }}</div>
      </div>
      <div class="dots-container">
        <div class="dot"></div>
      </div>
      <div class="checklist-container" *ngIf="checklist && checklist.ContractType == 0">
        <div class="icon-container">
          <mat-icon *ngIf="checklist && checklist.IsRepurhased" class="checklist-icon green">check_circle</mat-icon>
          <mat-icon *ngIf="checklist && !checklist.IsRepurhased" class="checklist-icon red">cancel</mat-icon>
        </div>
        <div class="checklist-name">{{ 'Turbo.TroubleshootSold.IsRepurhased' | translate:'Is repurchased?' }}</div>
      </div>
      <div class="dots-container" *ngIf="checklist && checklist.ContractType == 0">
        <div class="dot"></div>
      </div>
      <div class="checklist-container">
        <div class="icon-container">
          <mat-icon *ngIf="checklist && checklist.IsNotInsurance" class="checklist-icon green">check_circle</mat-icon>
          <mat-icon *ngIf="checklist && !checklist.IsNotInsurance" class="checklist-icon red">cancel</mat-icon>
        </div>
        <div class="checklist-name">{{ 'Turbo.TroubleshootSold.IsNotInsurance' | translate:'Is not insurance?' }}</div>
      </div>
      <div class="dots-container">
        <div class="dot"></div>
      </div>
      <div class="checklist-container">
        <div class="icon-container">
          <mat-icon *ngIf="checklist && checklist.TerminationTypeSell" class="checklist-icon green">check_circle</mat-icon>
          <mat-icon *ngIf="checklist && !checklist.TerminationTypeSell" class="checklist-icon red">cancel</mat-icon>
        </div>
        <div class="checklist-name">{{ 'Turbo.TroubleshootSold.TerminationTypeSell' | translate:'Is termination type sell?' }}</div>
      </div>
      <div class="dots-container">
        <div class="dot"></div>
      </div>
      <div class="checklist-container">
        <div class="icon-container">
          <mat-icon *ngIf="checklist && checklist.Price" class="checklist-icon green">check_circle</mat-icon>
          <mat-icon *ngIf="checklist && !checklist.Price" class="checklist-icon red">cancel</mat-icon>
        </div>
        <div class="checklist-name">{{ 'Turbo.TroubleshootSold.Price' | translate:'Is price set?' }}</div>
      </div>
    </div>
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate" style="margin-left: -15px; position: absolute; width: calc(100% + 30px); top: 0px;"></mat-progress-bar>
  </t4-container>
</mat-dialog-content>

